import { takeEvery, fork, all, takeLatest } from 'redux-saga/effects';
import {
    GET_SHIPPING_METHODS,
    GET_SHIP_TO_ADDRESS,
    GET_SURGERY_DETAILS,
    GET_DERIVED_TERRITORIES,
    UPDATE_CONSIGNMENT_ADD_DETAILS,
    updateDetailedconsignmentAddProductTemplateList,
    GET_PRODUCTS_BULK,
} from '../actions';

import {
    GET_DROPDOWN,
    GET_PRODUCTS,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    CREATE_PRODUCT_TEMPLATE,
    GET_TEMPLATE_DETAILS,
    UPDATE_PRODUCT_TEMPLATE,
    GET_DATA_FOR_PRODUCT_TEMPLATE,
    // GET_CONSIGNMENT_ADD_DETAILS,
    GET_CONSIGNMENT_ADD_MYCASEREF,
    SAVE_CONSIGNMENT_ADD_DETAILS,
    VALIDATE_ACCOUNT,
    VALIDATE_PRODUCTS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    GET_PRODUCT_DETAILS,
    GET_PRODUCTSGUIDE,
    GET_PRICES_FOR_ITEMS,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD,
    CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST,
    CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW,
    CONSIGNMENT_ADD_ORDER_FROM_USAGE_DETAILS,
    GET_DROPDOWN_OPTIONS,
    UPDATE_PRODUCT_TEMPLATE_LIST,
    GET_PRODUCT_BUNDLE,
    GET_TRANSFER_RECIPIENT_METHODS
} from '../actions/actionTypes';
import consignmentAddSearchProducts from './productsSearchSaga';
import consignmentAddSearchProductsBulk from './productsSearchBulkSaga';
import getconsignmentAddDropDownSaga from './getDropDownSaga';
import getconsignmentAddProductGuideSaga from './productsGuideSaga';
import validateProductsSaga from './validateProductsSaga';
//import productsTemplatesFilterSaga from './productsTemplatesFilterSaga';
import getShippingMethodsSaga from './shippingMethodsSaga';
import getShipToAddressSaga from './shipToAddressSaga';
import getProductDetailsSaga from './productDetailsSaga';
import getSurgeryDetailsSaga from './surgeryDetailsSaga';
import updateConsignmentAddSaga from './updateEquitySaga';
import getconsignmentAddCategoryAndBrands from './getEquityCategoryAndBrandsSaga';
import getconsignmentAddProductsByBrandOrSuperCategory from './getEquityProductsByBrandOrSuperCategorySaga';
import getDerivedTerritories from './derivedTerritorySaga';
import getTransferRecipient from './transferRecipientSaga';
import {
    createconsignmentAddProductTemplate,
    getDetailedconsignmentAddProductTemplates,
    getconsignmentAddTemplateDetails,
    updateconsignmentAddProductTemplate,
    getDataForconsignmentAddTemplate,
} from './productTemplateSaga';
import {
    // getConsignmentAddDetailsSaga,
    getConsignmentAddMyCaseRefSaga,
    usageAttachmentUploadSaga,
    deleteAttachmentSaga,
    getImagePoPreviewSaga,
} from './getConsignmentAddDetailsSaga';
import saveConsignmentAdd from './createEquitySaga';
import validateAccountSaga from './validateAccountSaga';
import getPricesForconsignmentAddItemsSaga from './getPricesForItemsSaga';
import consignmentAddOrderFromUsageDetails from './equityOrderFromUsageSaga';
import consignmentAddPriceOverrideSaga from './equityPriceOverrideSaga';
import consignmentAddSearchProductsBundle from './productSearchBundleSaga';

function* watchconsignmentAddGetDropDownSaga() {
    yield takeEvery(GET_DROPDOWN, getconsignmentAddDropDownSaga);
}

function* watchGetconsignmentAddProductsSaga() {
    yield takeEvery(GET_PRODUCTS, consignmentAddSearchProducts);
}

function* watchGetconsignmentAddProductsBulkSaga() {
    yield takeEvery(GET_PRODUCTS_BULK, consignmentAddSearchProductsBulk);
}

function* watchGetconsignmentAddProductsGuideSaga() {
    yield takeEvery(GET_PRODUCTSGUIDE, getconsignmentAddProductGuideSaga);
}

// function* watchGetProductsTemplatesFilterSaga() {
//     yield takeEvery(GET_PRODUCTSTEMPLATESFILTER, productsTemplatesFilterSaga);
// }

function* watchValidateconsignmentAddProductsSaga() {
    yield takeEvery(VALIDATE_PRODUCTS, validateProductsSaga);
}

function* watchGetProductDetailsSaga() {
    yield takeEvery(GET_PRODUCT_DETAILS, getProductDetailsSaga);
}

function* watchGetShipToAddressSaga() {
    yield takeEvery(GET_SHIP_TO_ADDRESS, getShipToAddressSaga);
}

function* watchGetShippingMethodsSaga() {
    yield takeEvery(GET_SHIPPING_METHODS, getShippingMethodsSaga);
}

function* watchSurgeryDetailsSaga() {
    yield takeLatest(GET_SURGERY_DETAILS, getSurgeryDetailsSaga);
}

function* watchUpdateconsignmentAddSaga() {
    yield takeLatest(UPDATE_CONSIGNMENT_ADD_DETAILS, updateConsignmentAddSaga);
}

function* watchGetconsignmentAddCategoryAndBrandsSaga() {
    yield takeLatest(
        GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
        getconsignmentAddCategoryAndBrands
    );
}

function* watchGetconsignmentAddProductsByBrandOrSuperCategorySaga() {
    yield takeLatest(
        GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        getconsignmentAddProductsByBrandOrSuperCategory
    );
}

function* watchGetDerivedTerritoriesSaga() {
    yield takeLatest(GET_DERIVED_TERRITORIES, getDerivedTerritories);
}

function* watchGetDetailedconsignmentAddProductTemplatesSaga() {
    yield takeLatest(
        GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        getDetailedconsignmentAddProductTemplates
    );
}

function* watchGetconsignmentAddProductTemplateDetailsSaga() {
    yield takeLatest(GET_TEMPLATE_DETAILS, getconsignmentAddTemplateDetails);
}

function* watchCreateconsignmentAddProductTemplateSaga() {
    yield takeLatest(
        CREATE_PRODUCT_TEMPLATE,
        createconsignmentAddProductTemplate
    );
}

function* watchUpdateconsignmentAddProductTemplateSaga() {
    yield takeLatest(
        UPDATE_PRODUCT_TEMPLATE,
        updateconsignmentAddProductTemplate
    );
}

function* watchGetDataForconsignmentAddProductTemplateSaga() {
    yield takeLatest(
        GET_DATA_FOR_PRODUCT_TEMPLATE,
        getDataForconsignmentAddTemplate
    );
}

function* watchUpdateDetailedconsignmentAddProductTemplatesSaga() {
    yield takeLatest(
        UPDATE_PRODUCT_TEMPLATE_LIST,
        updateDetailedconsignmentAddProductTemplateList
    );
}

// function* watchGetconsignmentAddDetailsSaga() {
//     yield takeLatest(GET_CONSIGNMENT_ADD_DETAILS, getConsignmentAddDetailsSaga);
// }

function* watchGetConsignmentAddMyCaseRefSaga() {
    yield takeLatest(
        GET_CONSIGNMENT_ADD_MYCASEREF,
        getConsignmentAddMyCaseRefSaga
    );
}

function* watchSaveconsignmentAddSaga() {
    yield takeLatest(SAVE_CONSIGNMENT_ADD_DETAILS, saveConsignmentAdd);
}

function* watchValidateAccountSaga() {
    yield takeLatest(VALIDATE_ACCOUNT, validateAccountSaga);
}

function* watchGetPricesForconsignmentAddItemsSaga() {
    yield takeLatest(GET_PRICES_FOR_ITEMS, getPricesForconsignmentAddItemsSaga);
}
function* watchUsageUploadAttcahmentSaga() {
    yield takeLatest(
        CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD,
        usageAttachmentUploadSaga
    );
}
function* watchUsageDeleteAttcahmentSaga() {
    yield takeLatest(
        CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST,
        deleteAttachmentSaga
    );
}
function* watchGetImagePOPreviewSaga() {
    yield takeLatest(
        CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW,
        getImagePoPreviewSaga
    );
}
function* watchconsignmentAddOrderFromUsageSaga() {
    yield takeLatest(
        CONSIGNMENT_ADD_ORDER_FROM_USAGE_DETAILS,
        consignmentAddOrderFromUsageDetails
    );
}

function* watchconsignmentAddPriceOverrideSaga() {
    yield takeLatest(GET_DROPDOWN_OPTIONS, consignmentAddPriceOverrideSaga);
}

function* watchGetconsignmentAddProductsBundleSaga() {
    yield takeEvery(GET_PRODUCT_BUNDLE, consignmentAddSearchProductsBundle);
}

function* watchConsignmentAddTransferRecipientSaga() {
    yield takeEvery(GET_TRANSFER_RECIPIENT_METHODS, getTransferRecipient);
}

export default function* consignmentAddRootSaga() {
    yield all([
        fork(watchconsignmentAddGetDropDownSaga),
        fork(watchGetconsignmentAddProductsGuideSaga),
        //fork(watchGetProductsTemplatesFilterSaga),
        fork(watchGetconsignmentAddProductsSaga),
        fork(watchGetconsignmentAddProductsBulkSaga),
        fork(watchGetProductDetailsSaga),
        fork(watchValidateconsignmentAddProductsSaga),
        // fork(watchGetProductDetailsSaga),
        fork(watchGetShippingMethodsSaga),
        fork(watchGetShipToAddressSaga),
        // fork(watchGetShippingBatchLocationsSaga),
        // fork(watchSaveSurgerySaga),
        fork(watchSurgeryDetailsSaga),
        fork(watchUpdateconsignmentAddSaga),
        fork(watchGetconsignmentAddCategoryAndBrandsSaga),
        fork(watchGetconsignmentAddProductsByBrandOrSuperCategorySaga),
        // fork(watchPutRecentlyUsedPhysicianSaga),
        fork(watchGetDerivedTerritoriesSaga),
        fork(watchGetDetailedconsignmentAddProductTemplatesSaga),
        fork(watchCreateconsignmentAddProductTemplateSaga),
        fork(watchGetconsignmentAddProductTemplateDetailsSaga),
        fork(watchUpdateconsignmentAddProductTemplateSaga),
        // fork(getHolidayListSaga),
        fork(watchGetDataForconsignmentAddProductTemplateSaga),
        // fork(watchGetconsignmentAddDetailsSaga),
        fork(watchGetConsignmentAddMyCaseRefSaga),
        fork(watchSaveconsignmentAddSaga),
        fork(watchValidateAccountSaga),
        fork(watchGetPricesForconsignmentAddItemsSaga),
        fork(watchUsageUploadAttcahmentSaga),
        fork(watchUsageDeleteAttcahmentSaga),
        fork(watchGetImagePOPreviewSaga),
        fork(watchconsignmentAddOrderFromUsageSaga),
        fork(watchconsignmentAddPriceOverrideSaga),
        fork(watchUpdateDetailedconsignmentAddProductTemplatesSaga),
        fork(watchGetconsignmentAddProductsBundleSaga),
        fork(watchConsignmentAddTransferRecipientSaga)
    ]);
}
